<template>
  <div class="vendor-create">
    <PageHeader title="Add Vendor" />

    <div class="shadow p-5 mt-2 mb-5 bg-white rounded">
      <VendorForm
        :model="vendor"
        :save-function="createVendor"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Vendor } from '@/models/vendor'
import PageHeader from '@/components/app/AppPageHeader.vue'
import { useHead } from '@unhead/vue'
import VendorForm from '../components/VendorForm.vue'
import { useRouter } from 'vue-router'
import { useNotification } from '@kyvg/vue3-notification'
import VendorService from '@/services/VendorService'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { ref } from 'vue'

useHead({ title: 'Add Vendor' })

const $router = useRouter()
const { notify } = useNotification()
const vendorService = new VendorService()
const vendor = ref(new Vendor())
const queryClient = useQueryClient()

const { mutateAsync:createVendor } = useMutation({
  mutationFn: (vendor: Vendor) => vendorService.create(vendor),
  onSuccess: (createdVendor: Vendor) => {
    notify({
      type: 'success',
      title: 'Vendor created',
      text: 'Vendor created successfully'
    })
    queryClient.setQueryData(['vendor', createdVendor.id], createdVendor)
    queryClient.invalidateQueries({ queryKey: ['vendors'] })
    $router.push({ name: 'ShowVendor', params: { id: createdVendor.id } })
  },
  onError: (error) => {
    notify({
      type: 'error',
      title: 'Error',
      text: error.message || 'An error occurred while trying to create the vendor'
    })
  }
})

</script>
